import React from "react";

// layout first to silence conflict css generation error
import Layout from "../core/layout/layout";

import { graphql } from "gatsby";
// import {
//   filterOutDocsPublishedInTheFuture,
//   filterOutDocsWithoutSlugs,
//   mapEdgesToNodes,
// } from "../blog/lib/helpers";

import GraphQLErrorList from "../blog/components/graphql-error-list";

// set component import
import Seo from "../core/layout/seo";
// import Container from "../blog/components/container";

import Landing from '../landing/Landing';

// preview image of website
import WebsitePreview from '../landing/assets/WebsitePreview.png';


export const query = graphql`
  query IndexPageQuery {
    author: sanityAuthor(slug: {current: {eq: "john"}}) {
      name
      roles
      image {
        alt
        asset {
          _id
        }
      }
      _rawBio
    }
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;

const IndexPage = (props) => {

  const { data, errors } = props;

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const site = (data || {}).site;

  const author = (data || {}).author;

  return (
    <Layout location={props.location}>
      <Seo
        title={site.title}
        description="Hi I'm John, a software developer and avid cook. Check out my website and blog to see what I've been up to recently!"
        keywords={site.keywords}
        setImage={WebsitePreview}
      />
      <Landing author={author}/>
    </Layout>
  );
};

export default IndexPage;
